module.exports = __webpack_public_path__ + "static/babili-e559fb9b44d3990799e275af497126f5.jpg";